import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IDropdownOption } from '../mat-dropdown/mat-dropdown.component';

const decisionDateType = [
  {
    id: 'dueDate',
    name: 'general.decisionDateType.dueDate',
  },
  {
    id: 'createdAt',
    name: 'general.decisionDateType.createdAt',
  },
  {
    id: 'eventDate',
    name: 'general.decisionDateType.eventDate',
  },
];

const actionItemType = [
  {
    id: 'issue',
    name: 'general.actionItemType.issues',
  },
  {
    id: 'action',
    name: 'general.actionItemType.actions',
  },
];

const statusCategory = [
  {
    id: 'todo',
    name: 'general.itemStatus.todo',
  },
  {
    id: 'inProgress',
    name: 'general.itemStatus.inProgress',
  },
  {
    id: 'done',
    name: 'general.itemStatus.done',
  },
];

const dateRange = [
  'today',
  'yesterday',
  'last7Days',
  'last30Days',
  'thisWeek',
  'lastWeek',
  'thisMonth',
  'lastMonth',
  'thisYear',
  'lastYear',
].map((id) => ({
  id,
  name: `system.label.dateRanges.${id}`,
}));

export const predefinedOptions = {
  actionItemType,
  dateRange,
  decisionDateType,
  statusCategory,
};

@Injectable({ providedIn: 'root' })
export class AdvancedFilterPredefinedData {
  private readonly translate = inject(TranslateService);

  public getOption(key: keyof typeof predefinedOptions): IDropdownOption<string | number | boolean>[] {
    return predefinedOptions[key].map((option) => ({ ...option, name: this.translate.instant(option.name) }));
  }
}
